export const callTypeGetDevicesCoordinates =
  'deviceCoordinates/getDevicesCoordinates';
